import React from "react";
import { BuildingIcon } from "./building-icon.jsx";
import { ChristmasIcon } from "./christmas-icon.jsx";
import { FilesignatureIcon } from "./file-signature-icon.jsx";
import { GlobeIcon } from "./globe-icon.jsx";
import { HeadsetIcon } from "./headset-icon.jsx";
import { LocationIcon } from "./location-icon.jsx";
import { LocationMapIcon } from "./location-map-icon.jsx";
import { MagnifyingGlassIcon } from "./magnifying-glass-icon.jsx";
import { MobileIcon } from "./mobile-icon.jsx";
import { NewspaperIcon } from "./newspaper-icon.jsx";
import { ShareIcon } from "./share-icon.jsx";
import { StampSearchIcon } from "./stamp-search-icon.jsx";
import { TrackingIcon } from "./tracking-icon.jsx";
import { WeightHangingIcon } from "./weight-hanging-icon.jsx";
import { RulerCombinedIcon } from "./ruler-combined-icon.jsx";

export const Icon = ({ variant }) => {
    return (
        <>
            {variant === "building" && <BuildingIcon />}
            {variant === "christmas" && <ChristmasIcon />}
            {variant === "filesignature" && <FilesignatureIcon />}
            {variant === "globe" && <GlobeIcon />}
            {variant === "headset" && <HeadsetIcon />}
            {variant === "location" && <LocationIcon />}
            {variant === "locationmap" && <LocationMapIcon />}
            {variant === "magnifyingglass" && <MagnifyingGlassIcon />}
            {variant === "mobile" && <MobileIcon />}
            {variant === "newspaper" && <NewspaperIcon />}
            {variant === "rulercombined" && <RulerCombinedIcon />}
            {variant === "stampsearch" && <StampSearchIcon />}
            {variant === "share" && <ShareIcon />}
            {variant === "tracking" && <TrackingIcon />}
            {variant === "weighthanging" && <WeightHangingIcon />}
        </>
    );
};
